import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignMagazineAboutHotelList } from "@/components/features/design/magazine/list/about";

import { useGetParams } from "./hooks/use-get-params";

export const DesignMagazineAboutHotelListPage = () => {
	const { hotelID } = useGetParams();

	return (
		<PageMeta
			title="マガジン記事の一覧 | 施設記事"
			url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.HOTEL, { hotelID })}
		>
			<DesignMagazineAboutHotelList hotelID={hotelID} />
		</PageMeta>
	);
};

DesignMagazineAboutHotelListPage.displayName = "DesignMagazineAboutHotelListPage";
